import { render, staticRenderFns } from "./LHvoices.vue?vue&type=template&id=4e80fe72&scoped=true"
import script from "./LHvoices.vue?vue&type=script&lang=js"
export * from "./LHvoices.vue?vue&type=script&lang=js"
import style0 from "./LHvoices.vue?vue&type=style&index=0&id=4e80fe72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e80fe72",
  null
  
)

export default component.exports